/** Wrapper around <HeadingItem> adding custom theming
 * @see @atlaskit/side-navigation
 */
/** @jsx jsx */
import type { ReactNode } from 'react';
import { css, jsx } from '@compiled/react';
import { HeadingItem } from '@atlaskit/side-navigation';
import { useSidebarTheme } from '../../../controllers/sidebar-theme/index.tsx';

const textColorCssVar = '--section-header-text-color';
const opacityCssVar = '--section-header-opacity';

const colorThemeStyles = css({
	color: `var(${textColorCssVar})`,
});

const opacityThemeStyles = css({
	opacity: `var(${opacityCssVar})`,
});

export type SectionHeaderProps = {
	children: ReactNode;
};

export const SectionHeader = ({ children }: SectionHeaderProps): JSX.Element => {
	const theme = useSidebarTheme();
	const item = theme?.navigation?.item;

	return (
		<HeadingItem
			// @ts-expect-error - className is a valid prop
			// eslint-disable-next-line @atlaskit/design-system/no-unsafe-style-overrides
			css={[item?.opacity && opacityThemeStyles, item?.color?.default && colorThemeStyles]}
			// eslint-disable-next-line jira/react/no-style-attribute
			style={{
				[opacityCssVar]: item?.opacity,
				[textColorCssVar]: item?.color?.default,
			}}
		>
			{children}
		</HeadingItem>
	);
};
